import { faqPlaceHolderData } from '~/utils/placeholderData'

export default () => {
    return useFetchWithTanstackQuery({
        queryKey: ['faq'],
        queryFn: () => $fetch('/api/translations/faq'),
        options: {
            placeholderData: faqPlaceHolderData,
        }
    })
}
